import { Button, Colors, Icon, MenuItem } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import styles from './StatusSelect.module.css';

const StatusSelectButton = ({
  statusObject,
  readOnly = false,
  disabled = false,
  small = false,
}) => {
  let statusColor = statusObject?.color || Colors.TURQUOISE2;

  return (
    statusObject && (
      <Button
        minimal
        small={readOnly}
        disabled={readOnly}
        className={`${
          small ? styles.status_label_small : styles.status_label
        } ${disabled ? styles.disabled : readOnly ? styles.inactive : ''}`}
        style={{
          backgroundColor: readOnly ? 'none' : statusColor,
        }}>
        <span
          style={{
            color: readOnly ? statusColor : Colors.WHITE,
          }}>
          {statusObject?.label || 'Status'}
        </span>
      </Button>
    )
  );
};

StatusSelectButton.propTypes = {
  statusObject: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  small: PropTypes.bool,
};

const StatusSelect = ({
  selectedStatusObject,
  onSelectStatus,
  statusObjectList,
  placeholder = 'Select a status',
  readOnly = false,
  disabled = false,
  small = false,
}) => {
  const [selectedItem, setSelectedItem] = useState(selectedStatusObject);

  useEffect(() => {
    if (selectedStatusObject) {
      selectedStatusObject && setSelectedItem(selectedStatusObject);
    }
  }, [selectedStatusObject]);

  const onItemSelected = (item) => {
    onSelectStatus && onSelectStatus(item);
  };

  const statusLabelRenderer = (statusObject, small = false) => {
    return statusObject ? (
      <StatusSelectButton
        statusObject={statusObject}
        readOnly={readOnly}
        disabled={disabled}
        small={small}
      />
    ) : (
      <Button intent={'primary'}>{placeholder}</Button>
    );
  };
  const itemRenderer = (
    statusItem,
    { handleClick, handleFocus, modifiers },
  ) => {
    return (
      <MenuItem
        key={statusItem.key}
        active={modifiers.active}
        onClick={handleClick}
        onFocus={handleFocus}
        text={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              width: '100%',
              padding: 4,
            }}>
            <Icon icon={statusItem === selectedItem ? 'tick' : 'blank'} />
            {statusLabelRenderer
              ? statusLabelRenderer(statusItem)
              : statusItem.label}
          </div>
        }
      />
    );
  };

  return (
    <Select
      fill
      popoverProps={{ minimal: true }}
      filterable={false}
      items={statusObjectList || []}
      itemsEqual={'key'}
      itemRenderer={itemRenderer}
      onItemSelect={onItemSelected}>
      {statusLabelRenderer
        ? statusLabelRenderer(selectedItem)
        : selectedItem.label}
    </Select>
  );
};

StatusSelect.propTypes = {
  selectedStatusObject: PropTypes.object.isRequired,
  onSelectStatus: PropTypes.func,
  statusObjectList: PropTypes.array,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  small: PropTypes.bool,
};

export { StatusSelect, StatusSelectButton };
